module.exports = __webpack_public_path__ + "static/grafika2@2x-a21568f64714a2c1776521bc0b846f38.png";